(function FAQ(SectionsDesign) {
  'use strict';

  if (SectionsDesign.faq) return;
  SectionsDesign.faq = {};

  var support = getSupport();

  var init = function () {
    var configNodes = Array.from(document.querySelectorAll('[data-faq-config]'));

    configNodes.map(function (configNode) {
      var section = compose(publicAPI, setEvents, getBlocks, getConfig)(configNode);
      SectionsDesign.faq[section.id] = section;
    });
  };

  init();

  function publicAPI(config) {
    return {
      id: config.sectionId,
      config: config,
      blocks: zipObj(config.blockIds, config.blocks),
      init: init
    };
  }

  //**************************

  /**
   * Click event.
   * @param {Object} block Section block elements and methods.
   * @return {Object} Section block elements and methods.
   */
  function blockEvents(block) {
    if (!block || !block.trigger) return block;
    if (block.trigger.hasAttribute('data-faq-init')) return block;

    block.trigger.setAttribute('data-faq-init', true);
    block.trigger.addEventListener('click', triggerClick);

    function triggerClick() {
      toggle(block);
    }

    return block;
  }

  /**
   * Toggle block state.
   * @param {Object} block Section block elements and methods.
   * @return {Object} Section block elements and methods.
   */
  function toggle(block) {
    block.collapsed ? expand(block) : collapse(block);
    return block;
  }

  /**
   * Expand block.
   * @param {Object} block Section block elements and methods.
   * @return {Object} Section block elements and methods.
   */
  function expand(block) {
    if (!block || !block.button || !block.panel) return block;

    block.button.setAttribute('aria-expanded', true);
    block.panel.removeAttribute('hidden');
    animate(block.panel, 'normal');
    return block;
  }

  /**
   * Collapse block.
   * @param {Object} block Section block elements and methods.
   * @return {Object} Section block elements and methods.
   */
  function collapse(block) {
    if (!block || !block.button || !block.panel) return block;

    block.button.setAttribute('aria-expanded', false);
    block.panel.setAttribute('hidden', '');
    animate(block.panel, 'reverse');
    return block;
  }

  /**
   * Collapsed block state.
   * @param {Object} block Section block elements and methods.
   * @return {boolean} Collapsed block state.
   */
  function isCollapsed(block) {
    return Boolean(block.button && block.button.getAttribute('aria-expanded') === 'false');
  }

  /**
   * Animate accordion.
   * @param {HTMLElement} element Block panel element to animate.
   * @param {String} direction Animation direction, normal or reverse.
   * @return {undefined} Nothing to return.
   */
  function animate(element, direction) {
    if (!support.WebAnimations) return;

    element.setAttribute('data-is-animating', true);

    element.animate(
      [{ height: 0 }, { height: element.offsetHeight + 'px' }],
      {
        duration: 240,
        fill: 'both',
        easing: 'cubic-bezier(0.4, 0.0, 0.2, 1)',
        direction: direction
      }
    ).onfinish = function () {
      element.removeAttribute('data-is-animating');
      this.cancel();
    };
  }

  //**************************

  /**
   * Maps all block IDs to exposed block API.
   * Filters out block IDs that don't exist in the DOM.
   * Scopes queries to the current section to avoid conflicts.
   * @param {Object} config Section and section blocks IDs.
   * @return {Object} config Section and section blocks IDs.
   */
  function getBlocks(config) {
    var root = document.getElementById('shopify-section-' + config.sectionId);
    if (!root) root = document;

    var validIds = [];
    var blocks = [];

    config.blockIds.forEach(function (blockId) {
      var b = block(blockId, root);
      if (b.trigger && b.button && b.panel) {
        validIds.push(blockId);
        blocks.push(b);
      }
    });

    // Keep ids + blocks aligned (critical for zipObj + theme editor hooks)
    config.blockIds = validIds;
    config.blocks = blocks;

    return config;
  }

  /**
   * Create section block API.
   * Scoped to section root.
   * @param {String} blockId Section Liquid block ID.
   * @param {HTMLElement} root Section root element.
   * @return {Object} block elements and methods.
   */
  function block(blockId, root) {
    return {
      trigger: root.querySelector('[data-faq-trigger="' + blockId + '"]'),
      button: root.querySelector('[data-faq-button="' + blockId + '"]'),
      panel: root.querySelector('[data-faq-panel="' + blockId + '"]'),

      get collapsed() { return isCollapsed(this); },
      select: function select() { return expand(this); },
      deselect: function deselect() { return collapse(this); }
    };
  }

  /**
   * Adds event listeners to block elements.
   * @param {Object} config Section and section blocks IDs.
   * @return {Object} config Section and section blocks IDs.
   */
  function setEvents(config) {
    config.blocks.forEach(blockEvents);
    return config;
  }

  /**
   * Pass the Liquid assigned section variables.
   * @param {HTMLElement} node Configuration script node.
   * @return {Object} Section and section blocks IDs.
   */
  function getConfig(node) {
    return JSON.parse(node.innerHTML);
  }

  /**
   * Feature detection.
   * @return {Object} Browser support.
   */
  function getSupport() {
    return {
      WebAnimations: (typeof Element.prototype.animate === 'function')
    };
  }

  //**************************

  /**
   * Creates a new object out of a list of keys and a list of values.
   * Key/value pairing is truncated to the length of the shorter of the two lists.
   * @param {Array} keys The array that will be properties on the output object.
   * @param {Array} values The list of values on the output object.
   * @return {Object} The object made by pairing up same-indexed elements of `keys` and `values`.
   */
  function zipObj(keys, values) {
    return keys.reduce(function zipObj(acc, key, idx) {
      acc[key] = values[idx];
      return acc;
    }, {});
  }

  /**
   * Performs right-to-left function composition.
   * The rightmost function may have any arity, the remaining functions must be unary.
   * @return {Function} Composed function
   */
  function compose() {
    var funcs = Array.prototype.slice.call(arguments).reverse();
    return function () {
      return funcs.slice(1).reduce(function (res, fn) {
        return fn(res);
      }, funcs[0].apply(undefined, arguments));
    };
  }

})(window.SectionsDesign = window.SectionsDesign || {});
